import aos from 'aos';
import 'aos/dist/aos.css';
import { track_link } from 'OchsnerJS/common/_freshpaint-event-tracking';

aos.init({
  duration: 1200,
});

// Link Tracking for WWW: Home
const wrapper = document.querySelector("#home .wrapper");
track_link("WWW: Home: Link Click", wrapper);
